import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { playPause, updateColor } from '../../../redux/slices/visualSlice';

const SelectionSort = ({ countIterations }) => {
  const myState = useSelector(state => state.updateProps);
  const dispatch = useDispatch();
  const timeoutsRef = useRef([]);
  const cancelledRef = useRef(false);

  const clearAllTimeouts = () => {
    cancelledRef.current = true;
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
  };

  const schedule = (fn, delay) => {
    if (cancelledRef.current) return;
    const id = setTimeout(() => {
      if (!cancelledRef.current) fn();
    }, delay);
    timeoutsRef.current.push(id);
  };

  const solve = () => {
    const values = myState.values.map(item => item[0]);
    const ids = myState.values.map(item => item[1]);
    const speed = myState.speed;
    const color = myState.color;
    const n = values.length;

    for (let i = 0; i < n; i++) {
      schedule(() => {
        countIterations(i);
        let ind = i;
        for (let j = i + 1; j < n; j++) {
          if (values[ind] > values[j]) ind = j;
        }
        [values[i], values[ind]] = [values[ind], values[i]];
        [ids[i], ids[ind]] = [ids[ind], ids[i]];

        document.getElementById(ids[i]).style.transform = `translateX(${i * 11}px)`;
        document.getElementById(ids[ind]).style.transform = `translateX(${ind * 11}px)`;
        document.getElementById(ids[i]).childNodes[1].style.backgroundColor = 'black';

        schedule(() => {
          document.getElementById(ids[i]).childNodes[1].style.backgroundColor = color;
        }, speed * 2);
      }, i * speed * 3);
    }

    schedule(() => {
      dispatch(playPause(false));
      dispatch(updateColor('rgb(0, 182, 0)'));
    }, speed * 3 * n + 50);
  };

  useEffect(() => {
    if (myState.algorithm === 'selection' && myState.play) {
      clearAllTimeouts();
      cancelledRef.current = false;
      solve();
    }
    return clearAllTimeouts;
  }, [myState.play]);

  useEffect(() => {
    return clearAllTimeouts;
  }, [myState.algorithm, myState.values]);

  return <></>;
};

export default SelectionSort;
